import { SkeletonType } from "Admin/Config/ImageType";
import { Skeleton } from "antd";

const LoadingSimpleComponent = ({ component, type, className, isLoading }) => {
  if (type == SkeletonType.IMAGE) {
    return (
      <div className={className}>
        {isLoading ? <Skeleton.Avatar active shape="circle" /> : component}
      </div>
    );
  } else if (type == SkeletonType.INPUT) {
    return (
      <div className={className}>
        {isLoading ? <Skeleton.Input active /> : component}
      </div>
    );
  } else if (type == SkeletonType.PARAGRAPH) {
    return (
      <div style={{ width: "100%" }} className={className}>
        {isLoading ? (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Skeleton
              active
              paragraph={{
                rows: 2,
              }}
            />
          </div>
        ) : (
          component
        )}
      </div>
    );
  }
};

export default LoadingSimpleComponent;
